import _ from 'lodash';
import React from 'react';
import { contentfulModels, contentfulViews, components } from '@glowforge/ui-common';

import './call-to-action-banner.less';

const { widgetDefaultProps, widgetPropType } = contentfulModels;
const { getWidget } = contentfulViews;
const { includeWhen } = components.reactUtils;

const CallToActionBanner = ({
  sections,
  model,
}) => {
  const textStrings = model.textStrings;
  const ctaText = textStrings['call-to-action-banner-text'];
  const buttons = _.map(sections, getWidget);
  const ctaButtons = includeWhen(buttons.length > 0, () => (
    <div className='ctaButtons'>{buttons}</div>
  ));
  return (
    <div className='CallToActionBanner fullWidth noMarginBottom'>
      <div className='content'>
        <div className='ctaText'>{ctaText}</div>
        {ctaButtons}
      </div>
    </div>
  );
};

CallToActionBanner.propTypes = widgetPropType;

CallToActionBanner.defaultProps = widgetDefaultProps;

export default CallToActionBanner;



// WEBPACK FOOTER //
// ./app/components/landing/call-to-action-banner.jsx